import {
    ufoEventRedirectToProduct,
    UfoCustomTimingKey,
    UfoCustomTimingWrapper
} from "@/components/signup/utils";

import { UserSegmentationProvider } from "./use-user-segmentation";
import ViewManager from "./view-manager";

const UserSegmentation = () => {
    return (
        <UfoCustomTimingWrapper
            ufoEvent={ufoEventRedirectToProduct}
            ufoCustomTimingKey={
                UfoCustomTimingKey.JIRA_USER_SEGMENTATION_DWELL_TIME
            }
        >
            <div data-testid="user-segmentation">
                <UserSegmentationProvider>
                    <ViewManager />
                </UserSegmentationProvider>
            </div>
        </UfoCustomTimingWrapper>
    );
};

export default UserSegmentation;
